import { apiProxy } from '@/libs/api/apiProxy'
import { GetVoiceNextResponse, PostVoiceSettingResponse } from '@/types/voice'

export const postVoiceSummary = (
  summaryId: number
): Promise<PostVoiceSettingResponse> => {
  return apiProxy.post<PostVoiceSettingResponse>(`/api/voice/${summaryId}`)
}

export const postVoice = (
  repeat: number,
  order: number,
  read: number,
  csrfToken: string
): Promise<PostVoiceSettingResponse> => {
  return apiProxy.post<PostVoiceSettingResponse>('/api/voice/setting', {
    repeat,
    order,
    read,
    csrfToken,
  })
}

export const getNextVoice = (
  summaryId: number
): Promise<GetVoiceNextResponse> => {
  return apiProxy.get<GetVoiceNextResponse>(
    `/api/voice/next?summary_id=${summaryId}`
  )
}
